/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_Step1Inputs */

const en_gc_resources_guide_analysis_step1 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the desktop app, create headers Category and Amount in A1:B1. Add Travel / 120, Supplies / 85 and Travel / 45 in rows 2 to 4.`)
};

const zh_gc_resources_guide_analysis_step1 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在桌面应用的 A1:B1 输入表头 Category 和 Amount。在第 2 至 4 行填入 Travel / 120、Supplies / 85、Travel / 45。`)
};

/**
* | output |
* | --- |
* | "In the desktop app, create headers Category and Amount in A1:B1. Add Travel / 120, Supplies / 85 and Travel / 45 in rows 2 to 4." |
*
* @param {Gc_Resources_Guide_Analysis_Step1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_step1 = /** @type {((inputs?: Gc_Resources_Guide_Analysis_Step1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_Step1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_step1(inputs)
	return zh_gc_resources_guide_analysis_step1(inputs)
});
export { gc_resources_guide_analysis_step1 as "gc.resources.guide.analysis.step1" }